$(".patterns_item_1").click(function(){
  $("#patterns_1").show()
  $("#patterns_2").hide()
  $("#patterns_3").hide()
  $("#patterns_4").hide()
  $("#patterns_5").hide()
  $("#patterns_6").hide()
})
$(".patterns_item_2").click(function(){
  $("#patterns_1").hide()
  $("#patterns_2").show()
  $("#patterns_3").hide()
  $("#patterns_4").hide()
  $("#patterns_5").hide()
  $("#patterns_6").hide()
})
$(".patterns_item_3").click(function(){
  $("#patterns_1").hide()
  $("#patterns_2").hide()
  $("#patterns_3").show()
  $("#patterns_4").hide()
  $("#patterns_5").hide()
  $("#patterns_6").hide()
})
$(".patterns_item_4").click(function(){
  $("#patterns_1").hide()
  $("#patterns_2").hide()
  $("#patterns_3").hide()
  $("#patterns_4").show()
  $("#patterns_5").hide()
  $("#patterns_6").hide()
})
$(".patterns_item_5").click(function(){
  $("#patterns_1").hide()
  $("#patterns_2").hide()
  $("#patterns_3").hide()
  $("#patterns_4").hide()
  $("#patterns_5").show()
  $("#patterns_6").hide()
})
$(".patterns_item_6").click(function(){
  $("#patterns_1").hide()
  $("#patterns_2").hide()
  $("#patterns_3").hide()
  $("#patterns_4").hide()
  $("#patterns_5").hide()
  $("#patterns_6").show()
})

var swiper1 = new Swiper(".mySwiper_pc_1", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: ".navigation_pc_next_1",
        prevEl: ".navigation_pc_prev_1",
    },
});
var swiper2 = new Swiper(".mySwiper_mobile_1", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
});
var swiper3 = new Swiper(".mySwiper_pc_2", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: ".navigation_pc_next_2",
        prevEl: ".navigation_pc_prev_2",
    },
});
var swiper4 = new Swiper(".mySwiper_mobile_2", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
});
var swiper5 = new Swiper(".mySwiper_pc_3", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: ".navigation_pc_next_3",
        prevEl: ".navigation_pc_prev_3",
    },
});
var swiper6 = new Swiper(".mySwiper_mobile_3", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
});
var swiper7 = new Swiper(".mySwiper_pc_4", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: ".navigation_pc_next_4",
        prevEl: ".navigation_pc_prev_4",
    },
});
var swiper8 = new Swiper(".mySwiper_mobile_4", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
});
var swiper9 = new Swiper(".mySwiper_pc_5", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: ".navigation_pc_next_5",
        prevEl: ".navigation_pc_prev_5",
    },
});
var swiper10 = new Swiper(".mySwiper_mobile_5", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
});
var swiper11 = new Swiper(".mySwiper_pc_6", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
        nextEl: ".navigation_pc_next_6",
        prevEl: ".navigation_pc_prev_6",
    },
});
var swiper12 = new Swiper(".mySwiper_mobile_6", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
});